export {getSunPosition, getSunDirection} from './suncalc';
